import { Component, inject } from '@angular/core';
import { LayoutContextService } from '../../layout-context.service';
import { HeaderModernComponent } from './variants/header-modern/header-modern.component';
import { HeaderMinimalComponent } from './variants/header-minimal/header-minimal.component';
import { HeaderPlatformComponent } from './variants/header-platform/header-platform.component';

@Component({
  selector: 'gb-header',
  standalone: true,
  imports: [
    HeaderModernComponent,
    HeaderMinimalComponent,
    HeaderPlatformComponent,
  ],
  template: `
    @if (ctx().route.headerEnabled) {
      @switch (ctx().slots.header) {
        @case ('platform') {
          <gb-header-platform [ctx]="ctx()" [transparent]="ctx().route.headerTransparent" />
        }
        @case ('modern') {
          <gb-header-modern [ctx]="ctx()" />
        }
        @case ('minimal') {
          <gb-header-minimal [ctx]="ctx()" />
        }
        @default {
          <gb-header-modern [ctx]="ctx()" />
        }
      }
    }
  `,
})
export class HeaderHostComponent {
  protected readonly ctx = inject(LayoutContextService).context;
}
